import { ALIGN_CLASSES as e, BLOCK_CLASSES as t } from "../../constants.js";
import { defineAttrs as n } from "../../utils/typed-attrs.js";
import { centerable as r } from "../decorators/centerable.js";
import { uploadable as i } from "../decorators/uploadable.js";
import "../decorators.js";
var a = r(i({
	inline: !1,
	draggable: !0,
	attrs: n({
		type: { default: "image" },
		src: { default: "" },
		linkUrl: { default: "" },
		width: { default: "" },
		displayWidth: { default: "" },
		height: { default: "" },
		text: { default: "" }
	}),
	group: "block",
	parseDOM: [{
		tag: ".intercom-interblocks-image",
		priority: 60,
		getAttrs(e) {
			let t = e.querySelector("img");
			if (!t) throw Error("img not found");
			return {
				src: t.getAttribute("src") ?? "",
				text: t.getAttribute("alt") ?? ""
			};
		}
	}, {
		tag: "img[src]",
		getAttrs(e) {
			return {
				src: e.getAttribute("src") ?? "",
				linkUrl: e.getAttribute("data-link-url") ?? "",
				width: e.getAttribute("data-width") || e.style.width.replace("px", ""),
				height: e.getAttribute("data-height") ?? "",
				text: e.getAttribute("alt") ?? ""
			};
		}
	}],
	toDOM(n) {
		let r = n.attrs, { src: i, width: a, height: o, text: s } = r, { displayWidth: c } = r;
		return c ||= a, [
			"div",
			{ class: `${t.blockContainer} ${t.image}` },
			["img", {
				src: i,
				...s && { alt: s },
				class: `${e[r.alignment] ?? ""}`,
				style: `display: block; width: ${c}px;`,
				"data-link-url": r.linkUrl,
				"data-height": o,
				"data-width": a
			}]
		];
	}
}));
//#endregion
export { a as imageSpec };
